import dayjs, { Dayjs } from "dayjs";
import { IoSearch, IoFilter } from "react-icons/io5";

type FilterProps = {
  searchValue: string;
  setSearchValue: (val: string) => void;
  filterDateRange: [Dayjs | null, Dayjs | null];
  setFilterDateRange: (val: [Dayjs | null, Dayjs | null]) => void;
  filterTimeRange: [Dayjs | null, Dayjs | null];
  setFilterTimeRange: (val: [Dayjs | null, Dayjs | null]) => void;
  showFilters: boolean;
  toggleFilters: () => void;
};

const FilterBar = ({
  searchValue,
  setSearchValue,
  filterDateRange,
  setFilterDateRange,
  filterTimeRange,
  setFilterTimeRange,
  showFilters,
  toggleFilters,
}: FilterProps) => {
  const handleReset = () => {
    setSearchValue("");
    setFilterDateRange([null, null]);
    setFilterTimeRange([null, null]);
  };

  return (
    <div className='space-y-4' dir='rtl'>
      {/* Search + Filter Icon */}
      <div className='flex items-center gap-2'>
        <div className='flex items-center gap-2 bg-white border border-red-300 rounded-full px-4 py-2 shadow-sm w-full'>
          <IoSearch className='text-lg text-red-500' />
          <input
            type='text'
            placeholder='ابحث برقم أو اسم...'
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            className='w-full text-sm bg-transparent outline-none placeholder:text-gray-400 text-right'
          />
        </div>
        <button
          onClick={toggleFilters}
          className='p-2 bg-white border border-red-300 rounded-full hover:bg-red-50 transition'
          title='تصفية متقدمة'
        >
          <IoFilter className='text-lg text-red-500' />
        </button>
      </div>

      {/* Filters Section */}
      {showFilters && (
        <div className='space-y-3 bg-red-50/10 p-4 border border-red-100 rounded-xl'>
          <div className='grid grid-cols-2 md:grid-cols-4 gap-4 text-sm'>
            {/* Date Filters */}
            <div className='flex flex-col'>
              <label className='mb-1 text-gray-600'>من تاريخ</label>
              <input
                type='date'
                value={filterDateRange[0]?.format("YYYY-MM-DD") ?? ""}
                onChange={(e) =>
                  setFilterDateRange([
                    dayjs(e.target.value),
                    filterDateRange[1],
                  ])
                }
                className='rounded-md border border-gray-300 px-3 py-1.5 focus:ring-1 focus:ring-red-500 focus:outline-none'
              />
            </div>
            <div className='flex flex-col'>
              <label className='mb-1 text-gray-600'>إلى تاريخ</label>
              <input
                type='date'
                value={filterDateRange[1]?.format("YYYY-MM-DD") ?? ""}
                onChange={(e) =>
                  setFilterDateRange([
                    filterDateRange[0],
                    dayjs(e.target.value),
                  ])
                }
                className='rounded-md border border-gray-300 px-3 py-1.5 focus:ring-1 focus:ring-red-500 focus:outline-none'
              />
            </div>

            {/* Time Filters */}
            <div className='flex flex-col'>
              <label className='mb-1 text-gray-600'>من وقت</label>
              <input
                type='time'
                value={filterTimeRange[0]?.format("HH:mm") ?? ""}
                onChange={(e) =>
                  setFilterTimeRange([
                    dayjs(e.target.value, "HH:mm"),
                    filterTimeRange[1],
                  ])
                }
                className='rounded-md border border-gray-300 px-3 py-1.5 focus:ring-1 focus:ring-red-500 focus:outline-none'
              />
            </div>
            <div className='flex flex-col'>
              <label className='mb-1 text-gray-600'>إلى وقت</label>
              <input
                type='time'
                value={filterTimeRange[1]?.format("HH:mm") ?? ""}
                onChange={(e) =>
                  setFilterTimeRange([
                    filterTimeRange[0],
                    dayjs(e.target.value, "HH:mm"),
                  ])
                }
                className='rounded-md border border-gray-300 px-3 py-1.5 focus:ring-1 focus:ring-red-500 focus:outline-none'
              />
            </div>
          </div>

          {/* Reset Button */}
          <div className='flex justify-end'>
            <button
              onClick={handleReset}
              className='px-4 py-1.5 bg-red-100 text-red-700 hover:bg-red-200 rounded-md text-sm font-medium transition'
            >
              إعادة التصفية
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterBar;
